module.exports = "This tool visualizes forest changes in Canada from 1985 to 2011.<br> Use the controls to refine the information displayed on the map. ";


//////////////////
// WEBPACK FOOTER
// ./src/js/tour/tourWelcome.html
// module id = 34
// module chunks = 0